import React, { useState, useContext, useMemo } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Box, Paper, Typography, TextField, Button } from "@mui/material";

const LoginForm: React.FC = () => {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const playerSn = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("player_sn") || null;
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await login(username, password, playerSn);
    if (!success) {
      setError("Login fehlgeschlagen. Bitte überprüfe Benutzername und Passwort.");
    } else {
      setError(null);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper 
        elevation={0} 
        sx={{ 
          p: 4, 
          minWidth: 320,
          backgroundColor: "#ffffff",
          border: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ textAlign: "center" }}>
          Login
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Benutzername"
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            inputProps={{ autoComplete: "username" }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          />
          <TextField
            fullWidth
            label="Passwort"
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            inputProps={{ autoComplete: "current-password" }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          />
          {error && (
            <Typography color="error" sx={{ mt: 1, mb: 1 }}>
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ 
              mt: 2,
              borderRadius: "10px",
            }}
          >
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginForm;
